export const HL7MessageSubfields: {
  [index: string]: {
    description: string;
    subfields?: keyof typeof HL7MessageSubfields;
  }[];
} = {
  AD: [
    { description: 'Street Address', subfields: 'ST' },
    { description: 'Other Designation', subfields: 'ST' },
    { description: 'City', subfields: 'ST' },
    { description: 'State or Province', subfields: 'ST' },
    { description: 'Zip or Postal Code', subfields: 'ST' },
    { description: 'Country', subfields: 'ID' },
    { description: 'Address Type', subfields: 'ID' },
    { description: 'Other Geographic Designation', subfields: 'ST' },
  ],
  AUI: [
    { description: 'Authorization Number', subfields: 'ST' },
    { description: 'Date', subfields: 'DT' },
    { description: 'Source', subfields: 'ST' },
  ],
  CCD: [
    { description: 'Invocation Event', subfields: 'ID' },
    { description: 'Date/time', subfields: 'TS' },
  ],
  CCP: [
    {
      description: 'Channel Calibration Sensitivity Correction Factor',
      subfields: 'NM',
    },
    { description: 'Channel Calibration Baseline', subfields: 'NM' },
    { description: 'Channel Calibration Time Skew', subfields: 'NM' },
  ],
  CD: [
    { description: 'Channel Identifier', subfields: 'WVI' },
    { description: 'Waveform Source', subfields: 'WVS' },
    { description: 'Channel Sensitivity/Units', subfields: 'CSU' },
    { description: 'Channel Calibration Parameters', subfields: 'CCP' },
    { description: 'Channel Sampling Frequency', subfields: 'NM' },
    { description: 'Minimum/Maximum Data Values', subfields: 'NR' },
  ],
  CE: [
    { description: 'Identifier', subfields: 'ST' },
    { description: 'Text', subfields: 'ST' },
    { description: 'Name of Coding System', subfields: 'ID' },
    { description: 'Alternate Identifier', subfields: 'ST' },
    { description: 'Alternate Text', subfields: 'ST' },
    { description: 'Name of Alternate Coding System', subfields: 'ID' },
  ],
  CF: [
    { description: 'Identifier', subfields: 'ST' },
    { description: 'Formatted Text', subfields: 'FT' },
    { description: 'Name of Coding System', subfields: 'ID' },
    { description: 'Alternate Identifier', subfields: 'ST' },
    { description: 'Alternate Formatted Text', subfields: 'FT' },
    { description: 'Name of Alternate Coding System', subfields: 'ID' },
  ],
  CNE: [
    { description: 'Identifier', subfields: 'ST' },
    { description: 'Text', subfields: 'ST' },
    { description: 'Name of Coding System', subfields: 'ID' },
    { description: 'Alternate Identifier', subfields: 'ST' },
    { description: 'Alternate Text', subfields: 'ST' },
    { description: 'Name of Alternate Coding System', subfields: 'ID' },
    { description: 'Coding System Version ID', subfields: 'ST' },
    { description: 'Alternate Coding System Version ID', subfields: 'ST' },
    { description: 'Original Text', subfields: 'ST' },
  ],
  CNN: [
    { description: 'ID Number', subfields: 'ST' },
    { description: 'Family Name', subfields: 'ST' },
    { description: 'Given Name', subfields: 'ST' },
    {
      description: 'Second and Further Given Names or Initials Thereof',
      subfields: 'ST',
    },
    { description: 'Suffix (e.g., JR or III)', subfields: 'ST' },
    { description: 'Prefix (e.g., DR)', subfields: 'ST' },
    { description: 'Degree (e.g., MD', subfields: 'IS' },
    { description: 'Source Table', subfields: 'IS' },
    { description: 'Assigning Authority   - Namespace ID', subfields: 'IS' },
    { description: 'Assigning Authority  - Universal ID', subfields: 'ST' },
    {
      description: 'Assigning Authority  - Universal ID Type',
      subfields: 'ID',
    },
  ],
  CP: [
    { description: 'Price', subfields: 'MO' },
    { description: 'Price Type', subfields: 'ID' },
    { description: 'From Value', subfields: 'NM' },
    { description: 'To Value', subfields: 'NM' },
    { description: 'Range Units', subfields: 'CE' },
    { description: 'Range Type', subfields: 'ID' },
  ],
  CQ: [
    { description: 'Quantity', subfields: 'NM' },
    { description: 'Units', subfields: 'CE' },
  ],
  CSU: [
    { description: 'Channel Sensitivity', subfields: 'NM' },
    { description: 'Unit of Measure Identifier', subfields: 'ST' },
    { description: 'Unit of Measure Description', subfields: 'ST' },
    { description: 'Unit of Measure Coding System', subfields: 'ID' },
    { description: 'Alternate Unit of Measure Identifier', subfields: 'ST' },
    { description: 'Alternate Unit of Measure Description', subfields: 'ST' },
    { description: 'Alternate Unit of Measure Coding System', subfields: 'ID' },
  ],
  CWE: [
    { description: 'Identifier', subfields: 'ST' },
    { description: 'Text', subfields: 'ST' },
    { description: 'Name of Coding System', subfields: 'ID' },
    { description: 'Alternate Identifier', subfields: 'ST' },
    { description: 'Alternate Text', subfields: 'ST' },
    { description: 'Name of Alternate Coding System', subfields: 'ID' },
    { description: 'Coding System Version ID', subfields: 'ST' },
    { description: 'Alternate Coding System Version ID', subfields: 'ST' },
    { description: 'Original Text', subfields: 'ST' },
  ],
  CX: [
    { description: 'ID Number', subfields: 'ST' },
    { description: 'Check Digit', subfields: 'ST' },
    { description: 'Check Digit Scheme', subfields: 'ID' },
    { description: 'Assigning Authority', subfields: 'HD' },
    { description: 'Identifier Type Code', subfields: 'ID' },
    { description: 'Assigning Facility', subfields: 'HD' },
    { description: 'Effective Date', subfields: 'DT' },
    { description: 'Expiration Date', subfields: 'DT' },
    { description: 'Assigning Jurisdiction', subfields: 'CWE' },
    { description: 'Assigning Agency or Department', subfields: 'CWE' },
  ],
  DDI: [
    { description: 'Delay Days', subfields: 'NM' },
    { description: 'Monetary Amount', subfields: 'MO' },
    { description: 'Number of Days', subfields: 'NM' },
  ],
  DIN: [
    { description: 'Date', subfields: 'TS' },
    { description: 'Institution Name', subfields: 'CE' },
  ],
  DLD: [
    { description: 'Discharge Location', subfields: 'IS' },
    { description: 'Effective Date', subfields: 'TS' },
  ],
  DLN: [
    { description: 'License Number', subfields: 'ST' },
    { description: 'Issuing State, Province, Country', subfields: 'IS' },
    { description: 'Expiration Date', subfields: 'DT' },
  ],
  DLT: [
    { description: 'Normal Range', subfields: 'NR' },
    { description: 'Numeric Threshold', subfields: 'NM' },
    { description: 'Change Computation', subfields: 'ID' },
    { description: 'Days Retained', subfields: 'NM' },
  ],
  DR: [
    { description: 'Range Start Date/Time', subfields: 'TS' },
    { description: 'Range End Date/Time', subfields: 'TS' },
  ],
  DTN: [
    { description: 'Day Type', subfields: 'IS' },
    { description: 'Number of Days', subfields: 'NM' },
  ],
  ED: [
    { description: 'Source Application', subfields: 'HD' },
    { description: 'Type of Data', subfields: 'ID' },
    { description: 'Data Subtype', subfields: 'ID' },
    { description: 'Encoding', subfields: 'ID' },
    { description: 'Data', subfields: 'TX' },
  ],
  EI: [
    { description: 'Entity Identifier', subfields: 'ST' },
    { description: 'Namespace ID', subfields: 'IS' },
    { description: 'Universal ID', subfields: 'ST' },
    { description: 'Universal ID Type', subfields: 'ID' },
  ],
  EIP: [
    { description: 'Placer Assigned Identifier', subfields: 'EI' },
    { description: 'Filler Assigned Identifier', subfields: 'EI' },
  ],
  ELD: [
    { description: 'Segment ID', subfields: 'ST' },
    { description: 'Segment Sequence', subfields: 'NM' },
    { description: 'Field Position', subfields: 'NM' },
    { description: 'Code Identifying Error', subfields: 'CE' },
  ],
  ERL: [
    { description: 'Segment ID', subfields: 'ST' },
    { description: 'Segment Sequence', subfields: 'NM' },
    { description: 'Field Position', subfields: 'NM' },
    { description: 'Field Repetition', subfields: 'NM' },
    { description: 'Component Number', subfields: 'NM' },
    { description: 'Sub-Component Number', subfields: 'NM' },
  ],
  FC: [
    { description: 'Financial Class Code', subfields: 'IS' },
    { description: 'Effective Date', subfields: 'TS' },
  ],
  FN: [
    { description: 'Surname', subfields: 'ST' },
    { description: 'Own Surname Prefix', subfields: 'ST' },
    { description: 'Own Surname', subfields: 'ST' },
    { description: 'Surname Prefix From Partner/Spouse', subfields: 'ST' },
    { description: 'Surname From Partner/Spouse', subfields: 'ST' },
  ],
  FT: [],
  HD: [
    { description: 'Namespace ID', subfields: 'IS' },
    { description: 'Universal ID', subfields: 'ST' },
    { description: 'Universal ID Type', subfields: 'ID' },
  ],
  ICD: [
    { description: 'Certification Patient Type', subfields: 'IS' },
    { description: 'Certification Required', subfields: 'ID' },
    { description: 'Date/Time Certification Required', subfields: 'TS' },
  ],
  JCC: [
    { description: 'Job Code', subfields: 'IS' },
    { description: 'Job Class', subfields: 'IS' },
    { description: 'Job Description Text', subfields: 'TX' },
  ],
  LA1: [
    { description: 'Point of Care', subfields: 'IS' },
    { description: 'Room', subfields: 'IS' },
    { description: 'Bed', subfields: 'IS' },
    { description: 'Facility', subfields: 'HD' },
    { description: 'Location Status', subfields: 'IS' },
    { description: 'Patient Location Type', subfields: 'IS' },
    { description: 'Building', subfields: 'IS' },
    { description: 'Floor', subfields: 'IS' },
    { description: 'Address', subfields: 'AD' },
  ],
  LA2: [
    { description: 'Point of Care', subfields: 'IS' },
    { description: 'Room', subfields: 'IS' },
    { description: 'Bed', subfields: 'IS' },
    { description: 'Facility', subfields: 'HD' },
    { description: 'Location Status', subfields: 'IS' },
    { description: 'Patient Location Type', subfields: 'IS' },
    { description: 'Building', subfields: 'IS' },
    { description: 'Floor', subfields: 'IS' },
    { description: 'Street Address', subfields: 'ST' },
    { description: 'Other Designation', subfields: 'ST' },
    { description: 'City', subfields: 'ST' },
    { description: 'State or Province', subfields: 'ST' },
    { description: 'Zip or Postal Code', subfields: 'ST' },
    { description: 'Country', subfields: 'ID' },
    { description: 'Address Type', subfields: 'ID' },
    { description: 'Other Geographic Designation', subfields: 'ST' },
  ],
  MA: [
    { description: 'Sample 1 From Channel 1', subfields: 'NM' },
    { description: 'Sample 1 From Channel 2', subfields: 'NM' },
    { description: 'Sample 1 From Channel N', subfields: 'NM' },
    { description: 'Sample 2 From Channel 1', subfields: 'NM' },
    { description: 'Sample 2 From Channel N', subfields: 'NM' },
    { description: 'Sample N From Channel N', subfields: 'NM' },
  ],
  MO: [
    { description: 'Quantity', subfields: 'NM' },
    { description: 'Denomination', subfields: 'ID' },
  ],
  MOC: [
    { description: 'Monetary Amount', subfields: 'MO' },
    { description: 'Charge Code', subfields: 'CE' },
  ],
  MOP: [
    { description: 'Money or Percentage Indicator', subfields: 'ID' },
    { description: 'Money or Percentage Quantity', subfields: 'NM' },
    { description: 'Currency Denomination', subfields: 'ID' },
  ],
  MSG: [
    { description: 'Message Code', subfields: 'ID' },
    { description: 'Trigger Event', subfields: 'ID' },
    { description: 'Message Structure', subfields: 'ID' },
  ],
  NA: [
    { description: 'Value1', subfields: 'NM' },
    { description: 'Value2', subfields: 'NM' },
    { description: 'Value3', subfields: 'NM' },
    { description: 'Value4', subfields: 'NM' },
  ],
  NDL: [
    { description: 'Name', subfields: 'CNN' },
    { description: 'Start Date/time', subfields: 'TS' },
    { description: 'End Date/time', subfields: 'TS' },
    { description: 'Point of Care', subfields: 'IS' },
    { description: 'Room', subfields: 'IS' },
    { description: 'Bed', subfields: 'IS' },
    { description: 'Facility', subfields: 'HD' },
    { description: 'Location Status', subfields: 'IS' },
    { description: 'Patient Location Type', subfields: 'IS' },
    { description: 'Building', subfields: 'IS' },
    { description: 'Floor', subfields: 'IS' },
  ],
  NR: [
    { description: 'Low Value', subfields: 'NM' },
    { description: 'High Value', subfields: 'NM' },
  ],
  OCD: [
    { description: 'Occurrence Code', subfields: 'CNE' },
    { description: 'Occurrence Date', subfields: 'DT' },
  ],
  OSD: [
    { description: 'Sequence/Results Flag', subfields: 'ID' },
    { description: 'Placer Order Number: Entity Identifier', subfields: 'ST' },
    { description: 'Placer Order Number: Namespace ID', subfields: 'IS' },
    { description: 'Filler Order Number: Entity Identifier', subfields: 'ST' },
    { description: 'Filler Order Number: Namespace ID', subfields: 'IS' },
    { description: 'Sequence Condition Value', subfields: 'ST' },
    { description: 'Maximum Number of Repeats', subfields: 'NM' },
    { description: 'Placer Order Number: Universal ID', subfields: 'ST' },
    { description: 'Placer Order Number: Universal ID Type', subfields: 'ID' },
    { description: 'Filler Order Number: Universal ID', subfields: 'ST' },
    { description: 'Filler Order Number: Universal ID Type', subfields: 'ID' },
  ],
  OSP: [
    { description: 'Occurrence Span Code', subfields: 'CNE' },
    { description: 'Occurrence Span Start Date', subfields: 'DT' },
    { description: 'Occurrence Span Stop Date', subfields: 'DT' },
  ],
  PIP: [
    { description: 'Privilege', subfields: 'CE' },
    { description: 'Privilege Class', subfields: 'CE' },
    { description: 'Expiration Date', subfields: 'DT' },
    { description: 'Activation Date', subfields: 'DT' },
    { description: 'Facility', subfields: 'EI' },
  ],
  PL: [
    { description: 'Point of Care', subfields: 'IS' },
    { description: 'Room', subfields: 'IS' },
    { description: 'Bed', subfields: 'IS' },
    { description: 'Facility', subfields: 'HD' },
    { description: 'Location Status', subfields: 'IS' },
    { description: 'Person Location Type', subfields: 'IS' },
    { description: 'Building', subfields: 'IS' },
    { description: 'Floor', subfields: 'IS' },
    { description: 'Location Description', subfields: 'ST' },
    { description: 'Comprehensive Location Identifier', subfields: 'EI' },
    { description: 'Assigning Authority for Location', subfields: 'HD' },
  ],
  PLN: [
    { description: 'ID Number', subfields: 'ST' },
    { description: 'Type of ID Number', subfields: 'IS' },
    { description: 'State/other Qualifying Information', subfields: 'ST' },
    { description: 'Expiration Date', subfields: 'DT' },
  ],
  PPN: [
    { description: 'ID Number', subfields: 'ST' },
    { description: 'Family Name', subfields: 'FN' },
    { description: 'Given Name', subfields: 'ST' },
    {
      description: 'Second and Further Given Names or Initials Thereof',
      subfields: 'ST',
    },
    { description: 'Suffix (e.g., JR or III)', subfields: 'ST' },
    { description: 'Prefix (e.g., DR)', subfields: 'ST' },
    { description: 'Degree (e.g., MD)', subfields: 'IS' },
    { description: 'Source Table', subfields: 'IS' },
    { description: 'Assigning Authority', subfields: 'HD' },
    { description: 'Name Type Code', subfields: 'ID' },
    { description: 'Identifier Check Digit', subfields: 'ST' },
    { description: 'Check Digit Scheme', subfields: 'ID' },
    { description: 'Identifier Type Code', subfields: 'ID' },
    { description: 'Assigning Facility', subfields: 'HD' },
    { description: 'Date/Time Action Performed', subfields: 'TS' },
    { description: 'Name Representation Code', subfields: 'ID' },
    { description: 'Name Context', subfields: 'CE' },
    { description: 'Name Validity Range', subfields: 'DR' },
    { description: 'Name Assembly Order', subfields: 'ID' },
    { description: 'Effective Date', subfields: 'TS' },
    { description: 'Expiration Date', subfields: 'TS' },
    { description: 'Professional Suffix', subfields: 'ST' },
    { description: 'Assigning Jurisdiction', subfields: 'CWE' },
    { description: 'Assigning Agency or Department', subfields: 'CWE' },
  ],
  PRL: [
    { description: 'Parent Observation Identifier', subfields: 'CE' },
    { description: 'Parent Observation Sub-identifier', subfields: 'ST' },
    { description: 'Parent Observation Value Descriptor', subfields: 'TX' },
  ],
  PT: [
    { description: 'Processing ID', subfields: 'ID' },
    { description: 'Processing Mode', subfields: 'ID' },
  ],
  PTA: [
    { description: 'Policy Type', subfields: 'IS' },
    { description: 'Amount Class', subfields: 'IS' },
    { description: 'Money or Percentage Quantity', subfields: 'NM' },
    { description: 'Money or Percentage', subfields: 'MOP' },
  ],
  QIP: [
    { description: 'Segment Field Name', subfields: 'ST' },
    { description: 'Values', subfields: 'ST' },
  ],
  QSC: [
    { description: 'Segment Field Name', subfields: 'ST' },
    { description: 'Relational Operator', subfields: 'ID' },
    { description: 'Value', subfields: 'ST' },
    { description: 'Relational Conjunction', subfields: 'ID' },
  ],
  RCD: [
    { description: 'Segment Field Name', subfields: 'ST' },
    { description: 'HL7 Data Type', subfields: 'ID' },
    { description: 'Maximum Column Width', subfields: 'NM' },
  ],
  RFR: [
    { description: 'Numeric Range', subfields: 'NR' },
    { description: 'Administrative Sex', subfields: 'IS' },
    { description: 'Age Range', subfields: 'NR' },
    { description: 'Gestational Age Range', subfields: 'NR' },
    { description: 'Species', subfields: 'ST' },
    { description: 'Race/subspecies', subfields: 'ST' },
    { description: 'Conditions', subfields: 'TX' },
  ],
  RI: [
    { description: 'Repeat Pattern', subfields: 'IS' },
    { description: 'Explicit Time Interval', subfields: 'ST' },
  ],
  RMC: [
    { description: 'Room Type', subfields: 'IS' },
    { description: 'Amount Type', subfields: 'IS' },
    { description: 'Coverage Amount', subfields: 'NM' },
    { description: 'Money or Percentage', subfields: 'MOP' },
  ],
  RP: [
    { description: 'Pointer', subfields: 'ST' },
    { description: 'Application ID', subfields: 'HD' },
    { description: 'Type of Data', subfields: 'ID' },
    { description: 'Subtype', subfields: 'ID' },
  ],
  RPT: [
    { description: 'Repeat Pattern Code', subfields: 'CWE' },
    { description: 'Calendar Alignment', subfields: 'ID' },
    { description: 'Phase Range Begin Value', subfields: 'NM' },
    { description: 'Phase Range End Value', subfields: 'NM' },
    { description: 'Period Quantity', subfields: 'NM' },
    { description: 'Period Units', subfields: 'IS' },
    { description: 'Institution Specified Time', subfields: 'ID' },
    { description: 'Event', subfields: 'ID' },
    { description: 'Event Offset Quantity', subfields: 'NM' },
    { description: 'Event Offset Units', subfields: 'IS' },
    { description: 'General Timing Specification', subfields: 'GTS' },
  ],
  SAD: [
    { description: 'Street or Mailing Address', subfields: 'ST' },
    { description: 'Street Name', subfields: 'ST' },
    { description: 'Dwelling Number', subfields: 'ST' },
  ],
  SCV: [
    { description: 'Parameter Class', subfields: 'CWE' },
    { description: 'Parameter Value', subfields: 'ST' },
  ],
  SN: [
    { description: 'Comparator', subfields: 'ST' },
    { description: 'Num1', subfields: 'NM' },
    { description: 'Separator/Suffix', subfields: 'ST' },
    { description: 'Num2', subfields: 'NM' },
  ],
  SPD: [
    { description: 'Specialty Name', subfields: 'ST' },
    { description: 'Governing Board', subfields: 'ST' },
    { description: 'Eligible or Certified', subfields: 'ID' },
    { description: 'Date of Certification', subfields: 'DT' },
  ],
  SPS: [
    { description: 'Specimen Source Name or Code', subfields: 'CWE' },
    { description: 'Additives', subfields: 'CWE' },
    { description: 'Specimen Collection Method', subfields: 'TX' },
    { description: 'Body Site', subfields: 'CWE' },
    { description: 'Site Modifier', subfields: 'CWE' },
    { description: 'Collection Method Modifier Code', subfields: 'CWE' },
    { description: 'Specimen Role', subfields: 'CWE' },
  ],
  SRT: [
    { description: 'Sort-by Field', subfields: 'ST' },
    { description: 'Sequencing', subfields: 'ID' },
  ],
  TQ: [
    { description: 'Quantity', subfields: 'CQ' },
    { description: 'Interval', subfields: 'RI' },
    { description: 'Duration', subfields: 'ST' },
    { description: 'Start Date/Time', subfields: 'TS' },
    { description: 'End Date/Time', subfields: 'TS' },
    { description: 'Priority', subfields: 'ST' },
    { description: 'Condition', subfields: 'ST' },
    { description: 'Text', subfields: 'TX' },
    { description: 'Conjunction', subfields: 'ID' },
    { description: 'Order Sequencing', subfields: 'OSD' },
    { description: 'Occurrence Duration', subfields: 'CE' },
    { description: 'Total Occurrences', subfields: 'NM' },
  ],
  TS: [
    { description: 'Time', subfields: 'DTM' },
    { description: 'Degree of Precision', subfields: 'ID' },
  ],
  TX: [],
  UVC: [
    { description: 'Value Code', subfields: 'CNE' },
    { description: 'Value Amount', subfields: 'MO' },
  ],
  VH: [
    { description: 'Start Day Range', subfields: 'ID' },
    { description: 'End Day Range', subfields: 'ID' },
    { description: 'Start Hour Range', subfields: 'TM' },
    { description: 'End Hour Range', subfields: 'TM' },
  ],
  VID: [
    { description: 'Version ID', subfields: 'ID' },
    { description: 'Internationalization Code', subfields: 'CE' },
    { description: 'International Version ID', subfields: 'CE' },
  ],
  VR: [
    { description: 'First Data Code Value', subfields: 'ST' },
    { description: 'Last Data Code Value', subfields: 'ST' },
  ],
  WVI: [
    { description: 'Channel Number', subfields: 'NM' },
    { description: 'Channel Name', subfields: 'ST' },
  ],
  WVS: [
    { description: 'Source One Name', subfields: 'ST' },
    { description: 'Source Two Name', subfields: 'ST' },
  ],
  XAD: [
    { description: 'Street Address', subfields: 'SAD' },
    { description: 'Other Designation', subfields: 'ST' },
    { description: 'City', subfields: 'ST' },
    { description: 'State or Province', subfields: 'ST' },
    { description: 'Zip or Postal Code', subfields: 'ST' },
    { description: 'Country', subfields: 'ID' },
    { description: 'Address Type', subfields: 'ID' },
    { description: 'Other Geographic Designation', subfields: 'ST' },
    { description: 'County/Parish Code', subfields: 'IS' },
    { description: 'Census Tract', subfields: 'IS' },
    { description: 'Address Representation Code', subfields: 'ID' },
    { description: 'Address Validity Range', subfields: 'DR' },
    { description: 'Effective Date', subfields: 'TS' },
    { description: 'Expiration Date', subfields: 'TS' },
  ],
  XCN: [
    { description: 'ID Number', subfields: 'ST' },
    { description: 'Family Name', subfields: 'FN' },
    { description: 'Given Name', subfields: 'ST' },
    {
      description: 'Second and Further Given Names or Initials Thereof',
      subfields: 'ST',
    },
    { description: 'Suffix (e.g., JR or III)', subfields: 'ST' },
    { description: 'Prefix (e.g., DR)', subfields: 'ST' },
    { description: 'Degree (e.g., MD)', subfields: 'IS' },
    { description: 'Source Table', subfields: 'IS' },
    { description: 'Assigning Authority', subfields: 'HD' },
    { description: 'Name Type Code', subfields: 'ID' },
    { description: 'Identifier Check Digit', subfields: 'ST' },
    { description: 'Check Digit Scheme', subfields: 'ID' },
    { description: 'Identifier Type Code', subfields: 'ID' },
    { description: 'Assigning Facility', subfields: 'HD' },
    { description: 'Name Representation Code', subfields: 'ID' },
    { description: 'Name Context', subfields: 'CE' },
    { description: 'Name Validity Range', subfields: 'DR' },
    { description: 'Name Assembly Order', subfields: 'ID' },
    { description: 'Effective Date', subfields: 'TS' },
    { description: 'Expiration Date', subfields: 'TS' },
    { description: 'Professional Suffix', subfields: 'ST' },
    { description: 'Assigning Jurisdiction', subfields: 'CWE' },
    { description: 'Assigning Agency or Department', subfields: 'CWE' },
  ],
  XON: [
    { description: 'Organization Name', subfields: 'ST' },
    { description: 'Organization Name Type Code', subfields: 'IS' },
    { description: 'ID Number', subfields: 'NM' },
    { description: 'Check Digit', subfields: 'NM' },
    { description: 'Check Digit Scheme', subfields: 'ID' },
    { description: 'Assigning Authority', subfields: 'HD' },
    { description: 'Identifier Type Code', subfields: 'ID' },
    { description: 'Assigning Facility', subfields: 'HD' },
    { description: 'Name Representation Code', subfields: 'ID' },
    { description: 'Organization Identifier', subfields: 'ST' },
  ],
  XPN: [
    { description: 'Family Name', subfields: 'FN' },
    { description: 'Given Name', subfields: 'ST' },
    {
      description: 'Second and Further Given Names or Initials Thereof',
      subfields: 'ST',
    },
    { description: 'Suffix (e.g., JR or III)', subfields: 'ST' },
    { description: 'Prefix (e.g., DR)', subfields: 'ST' },
    { description: 'Degree (e.g., MD)', subfields: 'IS' },
    { description: 'Name Type Code', subfields: 'ID' },
    { description: 'Name Representation Code', subfields: 'ID' },
    { description: 'Name Context', subfields: 'CE' },
    { description: 'Name Validity Range', subfields: 'DR' },
    { description: 'Name Assembly Order', subfields: 'ID' },
    { description: 'Effective Date', subfields: 'TS' },
    { description: 'Expiration Date', subfields: 'TS' },
    { description: 'Professional Suffix', subfields: 'ST' },
  ],
  XTN: [
    { description: 'Telephone Number', subfields: 'ST' },
    { description: 'Telecommunication Use Code', subfields: 'ID' },
    { description: 'Telecommunication Equipment Type', subfields: 'ID' },
    { description: 'Email Address', subfields: 'ST' },
    { description: 'Country Code', subfields: 'NM' },
    { description: 'Area/City Code', subfields: 'NM' },
    { description: 'Local Number', subfields: 'NM' },
    { description: 'Extension', subfields: 'NM' },
    { description: 'Any Text', subfields: 'ST' },
    { description: 'Extension Prefix', subfields: 'ST' },
    { description: 'Speed Dial Code', subfields: 'ST' },
    { description: 'Unformatted Telephone number', subfields: 'ST' },
  ],
  DT: [],
  DTM: [],
  GTS: [],
  ID: [],
  IS: [],
  NM: [],
  NUL: [],
  SI: [],
  ST: [],
  TM: [],
};
